import { render, staticRenderFns } from "./informationadd.vue?vue&type=template&id=c1fef8f2&scoped=true&"
import script from "./informationadd.vue?vue&type=script&lang=js&"
export * from "./informationadd.vue?vue&type=script&lang=js&"
import style0 from "./informationadd.vue?vue&type=style&index=0&id=c1fef8f2&lang=stylus&scoped=true&"
import style1 from "./informationadd.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1fef8f2",
  null
  
)

component.options.__file = "informationadd.vue"
export default component.exports